import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import themeConfig from "utils/theme-config"
const { screens } = themeConfig

const Footer = props => {
  const { className, footerFields, footerBottom, children } = props
  return (
    <footer className={className}>
      {footerFields?.length && (
        <div className="footer-fields-container">
          <div className="dry-container footer-fields">
            {footerFields.map((element, i) => (
              <div
                key={`footer-field-${i}`}
                className={`footer-field${
                  i === footerFields.length - 1 ? " last" : ""
                }`}
                dangerouslySetInnerHTML={{ __html: element.footerField }}
              ></div>
            ))}
          </div>
        </div>
      )}
      {footerBottom && <div className="footer-bottom">{footerBottom}</div>}
      {children}
    </footer>
  )
}

Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  footerFields: PropTypes.array,
  footerBottom: PropTypes.node,
}

const StyledFooter = styled(Footer)`
  background-color: var(--primary);
  font-size: 1.1rem;
  line-height: 2.5rem;

  .footer-fields-container {
    border-top-width: 8px;
    border-bottom-width: 8px;
    border-color: var(--gray5);
  }
  .footer-fields {
    padding: 2rem 1rem;
    text-align: center;
    color: var(--light);
  }
  .footer-field {
    position: relative;
    flex-grow: 1;
    padding-top: 2rem;
    padding-bottom: 2rem;
    &:after {
      content: "";
      height: 2px;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      bottom: 0;
      width: 50%;
      position: absolute;
      background: #fff;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  .footer-bottom {
    padding: 2rem 1rem;
    text-align: center;
    color: var(--light);
    background-color: var(--dark);
    a {
      border-bottom: 2px solid var(--gray1);
      padding-bottom: 4px;
    }
  }
  @media only screen and (min-width: ${screens.lg}) {
    .footer-fields {
      display: flex;
      justify-content: space-between;
    }
    .footer-field {
      &:after {
        width: 2px;
        height: 100%;
        margin-top: auto;
        margin-bottom: auto;
        left: auto;
        &:last-child {
          a:after {
            display: none;
          }
        }
      }
    }
  }
`

export default StyledFooter
export { Footer }
